import {
    Box,
    Chip
} from "@mui/material";

const RoundSelector = ({
    rounds,
    activeRound,
    setActiveRound,
    onAddRound
}) => {
    let defaultColor = '#002147';

    return (

        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
                mt: 1,
                flexWrap: "wrap"
            }}
        >

            {rounds.map((round, index) => (

                <Chip
                    key={round.id}
                    label={round.name}
                    clickable
                    sx={{
                        backgroundColor:
                            activeRound === index
                                ? defaultColor
                                : undefined,
                        color:
                            activeRound === index
                                ? "#fff"
                                : undefined,
                        "&:hover": {
                            backgroundColor:
                                activeRound === index
                                    ? defaultColor
                                    : undefined,
                        },
                    }}
                    onClick={() =>
                        setActiveRound(index)
                    }
                />

            ))}
            {rounds?.length < 4 && (
                <Chip
                    label="+ Round"
                    clickable
                    onClick={onAddRound}
                    sx={{
                        border: `1px solid ${defaultColor}`,
                        backgroundColor: "transparent",
                        color: defaultColor,
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        "&:hover": {
                            backgroundColor: "#f5f5f5",
                        },
                    }}
                />)}
            {/* <Button
                variant="outlined"
                size="small"
                onClick={onAddRound}
                style={{ color: defaultColor, borderColor: defaultColor, fontFamily: 'Poppins', fontWeight: 600 }}
            >
                + Round
            </Button> */}

        </Box>
    );
};

export default RoundSelector;